import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Eye, EyeSlash, CheckCircle } from "@phosphor-icons/react";

function formatErr(detail) {
  if (detail == null) return "Algo salió mal. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ");
  return String(detail);
}

export default function ResetPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password.length < 6) { setError("La contraseña debe tener al menos 6 caracteres."); return; }
    if (password !== confirm) { setError("Las dos contraseñas no coinciden. Escríbalas iguales."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email: email.trim(), new_password: password });
      setDone(true);
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="max-w-md mx-auto px-6 py-24 text-center" data-testid="reset-success">
        <CheckCircle size={52} weight="fill" className="mx-auto text-[#166534]" />
        <h1 className="font-serif text-3xl text-stone-900 mt-6">¡Contraseña cambiada!</h1>
        <p className="text-stone-500 mt-3">Ya puede iniciar sesión con su contraseña nueva.</p>
        <button onClick={() => navigate("/login")} className="mt-8 bg-[#3F4E4F] text-white px-8 py-3 hover:bg-[#2C3637]" data-testid="go-to-login">Ir a iniciar sesión</button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-6 py-20" data-testid="reset-password-page">
      <div className="text-center mb-8">
        <div className="font-serif text-3xl text-stone-900">Recuperar contraseña</div>
        <p className="text-stone-500 mt-2">Escriba su correo y una contraseña nueva</p>
      </div>
      <form onSubmit={submit} className="space-y-5">
        <div>
          <label className="label-caps text-stone-500 block mb-2">Correo electrónico</label>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@luxearoma.com" className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="reset-email-input" />
        </div>
        <div>
          <label className="label-caps text-stone-500 block mb-2">Contraseña nueva</label>
          <div className="relative">
            <input type={show ? "text" : "password"} required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border border-stone-300 px-4 py-3 pr-12 outline-none focus:border-[#3F4E4F]" data-testid="reset-password-input" />
            <button type="button" onClick={() => setShow(!show)} className="absolute right-3 top-1/2 -translate-y-1/2 text-stone-400 hover:text-stone-700" aria-label="Mostrar u ocultar">
              {show ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </div>
        </div>
        <div>
          <label className="label-caps text-stone-500 block mb-2">Repita la contraseña nueva</label>
          <input type={show ? "text" : "password"} required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full border border-stone-300 px-4 py-3 outline-none focus:border-[#3F4E4F]" data-testid="reset-confirm-input" />
        </div>
        {error && <div className="text-[#991B1B] text-sm" data-testid="reset-error">{error}</div>}
        <button type="submit" disabled={loading} className="w-full bg-[#3F4E4F] text-white py-4 hover:bg-[#2C3637] transition-colors disabled:opacity-50" data-testid="reset-submit-button">
          {loading ? "Guardando..." : "Cambiar contraseña"}
        </button>
      </form>
      <p className="text-center text-sm text-stone-500 mt-6">
        <Link to="/login" className="text-[#3F4E4F] font-medium hover:underline" data-testid="back-to-login">Volver a iniciar sesión</Link>
      </p>
    </div>
  );
}
